<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
  <!-- Hero Section -->
  <div class="text-center mb-16">
    <h1 class="text-4xl font-bold text-gray-900 mb-4">How This Power Play Works</h1>
    <p class="text-xl text-gray-600 max-w-3xl mx-auto">
      Welcome to the electron-ic chronicles of Golden fields! 💛🌾⚡ Where we track power like it's going out of style 
      (and defintely does, during load shedding and *faulty cables*).
    </p>
  </div>

  <!-- Data Collection Section -->
  <div class="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 mb-16">
    <h2 class="text-2xl font-bold text-gray-900 mb-4">How Fresh Is This Data?</h2>
    <p class="text-gray-600 mb-4">
      Every 3 minutes, our eager little data pipeline reaches out to fetch the latest inverter stats. Though our inverter's 
      server likes to take its sweet time (updating every 5-6 minutes), we're always ready to catch those electrons when they drop!
    </p>
    <p class="text-gray-600 mb-4">
      And yes, we capture everything - including those "surprise holiday" moments courtesy of load shedding and faulty cables. 🔦
    </p>
  </div>

  <!-- Features Section -->
  <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
    <div class="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
      <div class="text-blue-600 mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      </div>
      <h3 class="text-xl font-semibold mb-2">Real-Time(ish) Monitoring</h3>
      <p class="text-gray-600">Keeping tabs on power flow with the precision of a caffeinated squirrel counting nuts. Updates every 3 minutes!</p>
    </div>

    <div class="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
      <div class="text-blue-600 mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      </div>
      <h3 class="text-xl font-semibold mb-2">Load Shedding Aware</h3>
      <p class="text-gray-600">Yes, we track those "planned unexpected features" of South African life. Every dark moment is accounted for!</p>
    </div>

    <div class="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
      <div class="text-blue-600 mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
        </svg>
      </div>
      <h3 class="text-xl font-semibold mb-2">Peach Orchards Power House</h3>
      <p class="text-gray-600">Life's not always peachy when stuck in the dark, but here in the orchards, we're sparking joy! 🍑⚡ Monitoring power from our sun-soaked paradise, keeping things bright even when Eskom leaves us in a pit.</p>
    </div>
  </div>

  <!-- Technical Details -->
  <div class="bg-gray-50 rounded-xl p-8">
    <h2 class="text-3xl font-bold text-center mb-8">Behind the Scenes</h2>
    <p class="text-gray-600 text-center max-w-3xl mx-auto">
      Built with love, powered by coffee, and maintained with the kind of dedication usually reserved for 
      keeping houseplants alive during load shedding, but not real house plants, the plastic ones 🙈. Our pipeline connects to the inverter's server, 
      processes the data, and serves it up fresher than a Peach Orchards peach! (Wouldn't it be cool if we had a peach tree like the lemons in lemon tree?) 
    </p>
  </div>
</div>
